import React from 'react'
import { CoreContainer } from '@hub/core-container'
import { Box } from '@hub/box'

export const BreadcrumbContainer: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return (
    <CoreContainer isMobileFullWidth>
      <Box
        sx={{
          marginTop: ['spacing-sm', 'spacing-sm', 'spacing-md'],
          marginBottom: ['spacing-sm', 'spacing-sm', 'spacing-md'],
          marginLeft: ['spacing-md', 'spacing-none'],
          marginRight: ['spacing-md', 'spacing-none'],
        }}
      >
        {children}
      </Box>
    </CoreContainer>
  )
}
